import React, { useState, useEffect, useCallback } from "react";
import { Container, Box, CircularProgress } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  IconButton,
  Avatar,
  Chip,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Divider,
  Popover,
  ButtonGroup,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  Assignment,
  Group,
  Close,
  ArrowForwardIos,
  CheckCircle,
  Block,
  Receipt,
  DateRange,
  HourglassEmpty
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { DatePicker } from "@material-ui/pickers";

import { makeStyles } from "@material-ui/styles";

import MUIDataTable from "mui-datatables";
import { TableFooter, TableCell, TableRow } from "@material-ui/core";

import { Skeleton } from "@material-ui/lab";
import Format from "date-fns/format";


import { useSnackbar } from "notistack";

import {
  FinanceService,
  AdminService,
  ReportingService,
  Validator,
} from "../../../../../../utils/web_config";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function StockRequest(props) {
  const classes = useStyles();
  const history = useHistory();

  const [accountData, setAccountData] = useState({});
  const [transactions, setTransactions] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    status: "Loading stock requests...",
    loading: false,
    toggling: false,
    data: [],
  });

  const [distribution,setDistribution]=useState({saving:false})

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [detailsOpen,setDetailsOpen]=useState({open:false,data:[]})

  const [from, setFrom] = useState({
    value: new Date(),
    error: "",
  });
  const [to, setTo] = useState({
    value: new Date(),
    error: "",
  });
  const [range, setRange] = useState({ index: 0, acnhor: null });

  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    getTransactions(accountData.token, from.value, to.value);
  }, []);

  const onFromChange = (date) => {
    setFrom({ value: date, error: "" });
    setRange({ ...range, index: null });
    getTransactions(accountData.token, date, to.value);
  };
  const onToChange = (date) => {
    setTo({ value: date, error: "" });
    setRange({ ...range, index: null });
    getTransactions(accountData.token, from.value, date);
  };


  //////////////

  const columns = [

    {
      name: "item_name",
      label: "Item name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "item_type_name",
      label: "Item type",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "quantity",
      label: "Quantity",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "damaged_quantity",
      label: "Damaged quantity",
      options: {
        filter: false,
        sort: false,
      },
    },
  ];

  ////////////
  const options = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "none",
    searchPlaceholder: "Search item...",
    selectableRowsOnClick: true,
    fixedHeader: true,
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: "No items available",
      },
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      //  <CustomUsersToolbar
      //    selectedRows={selectedRows}
      //    displayData={displayData}
      //    setSelectedRows={setSelectedRows}
      //    toggleUser={toggleUser}
      //    openEdit={showUserEdit}
      //    toggling={allItems.toggling}
      //  />
      <></>
    ),
  };

  //////////
  const transactionsColums = [
    {
      name: "id",
      label: "id",
      options: {
        filter: false,
        sort: false,
        display: "excluded",
      },
    },
    {
      name: "customer_name",
      label: "Customer",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "item_type",
      label: "Item Type",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "quantity",
      label: "Quantity",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "created_at",
      label: "Created At",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "request_status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Chip
              avatar={
                <Avatar>
                    <HourglassEmpty fontSize="small" />
                </Avatar>
              }
              variant="outlined"
              size="small"
              label={capitalize(transactions.data[dataI]?.status)}
            />
          );
        },
      },
    },
    {
      name: "items",
      label: "Items",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Button  size='small' variant='outlined' className={classes.btn} onClick={()=>{
              console.log(transactions.data[dataI]);
              setRequestId({value:transactions.data[dataI]['id'],error:""});
              setItemId({value:transactions.data[dataI]['item_category']['id'],error:""});
              setCustomerId({value:transactions.data[dataI]['customer']['id']}); 
              setDialogSale(true);
            }}>Sale</Button>
          );
        },
      },
    },
  ];

  const transactionsOptions = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "none",
    searchPlaceholder: "Search movement here...",
    selectableRowsOnClick: true,
    fixedHeader: true,
  
    renderExpandableRow: (rowData, rowMeta) => {
  
      return transactions.data[rowMeta.dataIndex].items?.map((it, i) => (
        <TableRow>
          <TableCell>{it.item_name}</TableCell>
          <TableCell>{it.item_type_name}</TableCell>
          <TableCell>{it.quantity}</TableCell>
          <TableCell>{it.damaged_quantity}</TableCell>
        </TableRow>
      ));
    },
  
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: transactions.status,
      },
    },
    customTableBodyFooterRender: function (opts) {

      let sumQuantity = opts.data
        ?.map((item) => item.data[3])
        .reduce((prev, curr) => prev + curr, 0);

      let sumDamaged = opts.data
        ?.map((item) => item.data[5])
        .reduce((prev, curr) => prev + curr, 0);

      sumQuantity = Math.round(sumQuantity);
      sumDamaged = Math.round(sumDamaged);

      return (
        <TableFooter className={classes.stickyFooter}>
          <TableRow>
            {opts.selectableRows !== "none" ? (
              <TableCell className={classes.stickyFooter} />
            ) : null}
            {opts.columns.map((col, index) => {
              if (col.display === "true") {
                if (col.name === "quantity") {
                  return (
                    <TableCell key={index} className={classes.stickyFooter}>
                      Total:<b> {sumQuantity}</b>
                    </TableCell>
                  );
                } else if (col.name === "damaged_quantity") {
                  return (
                    <TableCell key={index} className={classes.stickyFooter}>
                      Total:<b> {sumDamaged} </b>
                    </TableCell>
                  );
                } else {
                  return (
                    <TableCell key={index} className={classes.stickyFooter} />
                  );
                }
              }
              return null;
            })}
          </TableRow>
        </TableFooter>
      );
    },
  };

  /////////////////////
  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const capitalize = (s) => {
    if (s == null) {
      s = "Pending";
    }
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };
  ///////////////////////////////////
  ///////////////////////////////////

  const getTransactions = (token, fromDate, toDate) => {
    const createInstance = axios.create(new AdminService().getHeaders(token));

    setTransactions({ ...transactions, loading: true });

    console.log("getting pending request .....");

  

    createInstance
      .get(new ReportingService().GET_PENDING_REQUEST)
      .then(function (response) {
        setTransactions({ ...transactions, loading: false });

        const d = response.data;

        if (d.data.content.length == 0) {
          setTransactions({
            ...transactions,
            data: d.data.content,
            status: "There are no pending requests available ",
          });
        } else {
          var objs=d.data.content;
          objs.map((o)=>{
            o['item_type']=o.item_category.item_type;
            o['customer_name']=o.customer.full_names;
          });
          var groups = new Validator().groupArrayOfObjects(
            objs,
            "item_type"
          );
          var keys = Object.keys(groups);

          setTransactions({
            ...transactions,
            data:objs,
            allData: objs,
            keys: keys,
            groups: groups,
          });
        }
      })
      .catch(function (error) {
        setTransactions({ ...transactions, loading: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setTransactions({ ...transactions, status: e });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  //////////////////////////////////

    ////////////////////////
    const distributeStock = () => {
      const createInstance = axios.create(
        new AdminService().getHeaders(accountData.token)
      );
  
      setDistribution({ ...distribution, saving: true });

      const data = {
        movement_type: "STOCK_OUT",
        stock_order_id: detailsOpen.data?.movement_id,
      };
  
      createInstance
        .post(new ReportingService().GIVE_STOCK, data)
        .then(function (response) {
          setDistribution({ ...distribution, saving: false });
          var d = response.data;
  
          setDetailsOpen({
            ...detailsOpen,
            open: false,
          });
  
          getTransactions(accountData.token,from.value,to.value)
          notify("success", response.data.message);
        })
        .catch(function (error) {
          setDistribution({ ...distribution, saving: false });
          var e = error.message;
  
          if (error.response) {
            e = error.response.data.message;
          }
  
          notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
        });
    };



    /////////////////////////// get items //////////////

    const [items,setItems]=useState({data:[],loading:false});
    const get_items=()=>{
      const createInstance = axios.create(new AdminService().getHeaders(accountData.token));

      setTransactions({ ...transactions, loading: true });
  
      console.log("getting pending request .....");
  
    
  
      createInstance
        .get(new ReportingService().GET_PENDING_REQUEST)
        .then(function (response) {
          setTransactions({ ...transactions, loading: false });
  
          const d = response.data;
  
          if (d.data.content.length == 0) {
            setTransactions({
              ...transactions,
              data: d.data.content,
              status: "There are no pending requests available ",
            });
          } else {
            var objs=d.data.content;
            objs.map((o)=>{
              o['item_type']=o.item_category.item_type;
              o['customer_name']=o.customer.full_names;
            });
            var groups = new Validator().groupArrayOfObjects(
              objs,
              "item_type"
            );
            var keys = Object.keys(groups);
  
            setTransactions({
              ...transactions,
              data:objs,
              allData: objs,
              keys: keys,
              groups: groups,
            });
          }
        })
        .catch(function (error) {
          setTransactions({ ...transactions, loading: false });
  
          var e = error.message;
  
          if (error.response) {
            e = error.response.data.message;
          }
          setTransactions({ ...transactions, status: e });
  
          notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
        });
    }


    //////////////////////// end get items /////////////


    /////////////// sale request ///////////////////////

    const [dialogSale,setDialogSale]=useState(false);
    const [loadingSale,setLoadingSale]=useState(false);
    const [customerId,setCustomerId]=useState({value:0,error:""});
    const [itemId,setItemId]=useState({value:0,error:""});
    const [location,setLocation]=useState({value:"",error:""});
    const [paymentAmount,setPaymentAmount]=useState({value:0,error:""});
    const [paymentMethod,setPaymentMethod]=useState({value:"",error:""});
    const [paymentType,setPaymentType]=useState({value:"",error:""});
    const [requestId,setRequestId]=useState({value:0,error:""});

    const sale_item=()=>{
      if(customerId.value==0){
        setCustomerId({value:0,error:"No customer presented"});
      }else if(itemId.value==0){
        setItemId({value:0,error:"No item presented"});
      }else if(paymentMethod.value==""){
        setPaymentMethod({value:"",error:"Please select payment method"});
      }else if(paymentAmount.value==0){
        setPaymentAmount({value:0,error:"Please procide correct amount"});
      }else{
        let data={
          "customer_id": customerId.value,
          "item_id": itemId.value,
          "location": location.value,
          "payment_amount": paymentAmount.value,
          "payment_method": paymentMethod.value,
          "payment_type": paymentType.value,
          "request_id": requestId.value
        };
        setLoadingSale(true);
        const saleInstance = axios.create(new AdminService().getHeaders(accountData.token));
        saleInstance
        .post(new ReportingService().SALE_ITEM,data)
        .then(function (response) {
          setLoadingSale(false);
  
          const d = response.data;

          console.log("response",d);
          setDialogSale(false);
         
        })
        .catch(function (error) {

          setLoadingSale(false);
          var e = error.message;
  
          if (error.response) {
            e = error.response.data.message;
          }
          notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
        });
      }
    }

    ////////////// end sale request /////////////////

    

  return (
   
    <div className={classes.root}>
      {/* Dialogs ends here */}

      <Popover
        id={"pop-id"}
        open={range.acnhor != null}
        anchorEl={range.acnhor}
        onClose={() => setRange({ ...range, acnhor: null })}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        elevation={4}
      >
        <Box p={2}>
          <Typography color="textSecondary">Select date range</Typography>
          <Box mt={2} mb={2}>
            <Box>
              <DatePicker
                fullWidth
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                maxDate={to.value}
                autoOk
                label={<Translate id="reports.forms.labels.from" />}
                value={from.value}
                inputVariant="outlined"
                onChange={onFromChange}
                InputProps={{
                  disableUnderline: true,
                  style: { paddingRight: 0 },
                }}
              />
            </Box>
            <Box>
              <DatePicker
                fullWidth
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                minDate={from.value}
                autoOk
                label={<Translate id="reports.forms.labels.to" />}
                value={to.value}
                inputVariant="outlined"
                onChange={onToChange}
                InputProps={{
                  disableUnderline: true,
                  style: { paddingRight: 0 },
                }}
              />
            </Box>
          </Box>
        </Box>
      </Popover>

 {/* ////////////////////////    sale dialog ////////////////////////// */}

      <Dialog
        open={dialogSale}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth='sm'
        fullWidth
        onClose={()=>setDialogSale(false)}
      >
        <DialogTitle id="alert-dialog-title">Sale Item</DialogTitle>
        <DialogContent>
        <Box mt={2}>
          <TextField
                  required
                  size="small"
                  variant="outlined"
                  color="primary"
                  value={paymentAmount.value}
                  placeholder={"Payment Amount"}
                  label={"Payment Amount"}
                  fullWidth
                  onChange={(e)=>{
                    setPaymentAmount({value:e.target.value,error:""});
                  }}
                  helperText={paymentAmount.error}
                  error={paymentAmount.error !== ""}
                />
          </Box>
          <Box mt={2}>
          <TextField
                  required
                  size="small"
                  variant="outlined"
                  color="primary"
                  value={location.value}
                  placeholder={"Location"}
                  label={"Location"}
                  fullWidth
                  onChange={(e)=>{
                    setLocation({value:e.target.value,error:""});
                  }}
                  helperText={location.error}
                  error={location.error !== ""}
                />
          </Box>

          <Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={paymentType.error!=""}
            >
              <InputLabel>
                <Typography>Payment Type</Typography>
              </InputLabel>
              <Select
                label={"Payment Type"}
                value={paymentType.value}
                onChange={(e)=>{
                  setPaymentType({value:e.target.value,error:""});
                }}
              >
                {["DIRECT","LOAN"]?.map((tp, i) => (
                  <MenuItem value={tp}>{tp}</MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {paymentType.error}
              </FormHelperText>
            </FormControl>
          </Box>

          <Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={paymentMethod.error!=""}
            >
              <InputLabel>
                <Typography>Payment Method</Typography>
              </InputLabel>
              <Select
                label={"Payment Type"}
                value={paymentMethod.value}
                onChange={(e)=>{
                  setPaymentMethod({value:e.target.value,error:""});
                }}
              >
                {["CASH","MTN_MOBILE_MONEY","AIRTEL_MONEY","CARD","BANK_TRANSFER","BOOKING","PROMOTION"]?.map((tp, i) => (
                  <MenuItem value={tp}>{tp}</MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {paymentMethod.error}
              </FormHelperText>
            </FormControl>
          </Box>

        </DialogContent>
        <DialogActions>
          <Button 
           variant='outlined'
          onClick={() => {
            setDialogSale(false);
          }} color="primary">
            Cancel
          </Button>
          <Button 
          variant='contained'
          disableElevation
          disabled={loadingSale}s
          onClick={() => {
            sale_item();
          }} color="primary" autoFocus>
            {loadingSale? <CircularProgress size={23} /> : "Save"}
          </Button>
         
        </DialogActions>
      </Dialog>

{/* ///////////////////////////  end sale dialog //////////////////////////// */}


      {/* ////////////////////////////// */}
      <Box display="flex" alignItems="center">
        <Box flexGrow={1} display="flex" alignItems="center">
          <Typography variant="h6">
            <b>Stock requests</b>
          </Typography>
        </Box>



        {/* <Box display="flex" mr={2} alignItems="center">
          <Box mr={2}>
            <ButtonGroup color="primary" disableElevation>
              <Button
                className={classes.btn}
                variant={range.index == 0 ? "contained" : "outlined"}
                onClick={() => {
                  setRange({ index: 0 });
                  var date1 = new Date();
                  var date2 = new Date();

                  setFrom({ value: date1 });
                  setTo({ value: date2 });
                  getTransactions(accountData.token, date1, date2);
                }}
              >
                Today
              </Button>
              <Button
                className={classes.btn}
                variant={range.index == 1 ? "contained" : "outlined"}
                onClick={() => {
                  setRange({ index: 1 });
                  var date1 = new Date();
                  date1.setDate(date1.getDate() - 7);
                  var date2 = new Date();

                  setFrom({ value: date1 });
                  setTo({ value: date2 });
                  getTransactions(accountData.token, date1, date2);
                }}
              >
                Last week
              </Button>
              <Button
                className={classes.btn}
                variant={range.index == 2 ? "contained" : "outlined"}
                onClick={() => {
                  setRange({ index: 2 });
                  var date1 = new Date();
                  date1.setDate(date1.getDate() - 30);
                  var date2 = new Date();

                  setFrom({ value: date1 });
                  setTo({ value: date2 });
                  getTransactions(accountData.token, date1, date2);
                }}
              >
                Last month
              </Button>
            </ButtonGroup>
          </Box>

          <IconButton
            color="primary"
            onClick={(e) => setRange({ ...range, acnhor: e.currentTarget })}
          >
            <DateRange />
          </IconButton>
        </Box> */}
      </Box>
      <Box mt={3} />
      {transactions.loading && <LinearProgress />}
      <MUIDataTable
        title={
          "From " +
          Format(from.value, ["MMMM dd"]) +
          " to " +
          Format(to.value, ["MMMM dd"])
        }
        data={transactions.data}
        columns={transactionsColums}
        options={transactionsOptions}
      />
    </div>

  );
}

export default withLocalize(StockRequest);
